import { AdvertIcalService } from "@ephatta/services"
import { config } from "config"

export const useAdvertIcalService = () => {
    return new AdvertIcalService(config)
}
